<div class="time-filter" [ngClass]="['time-picker-' + timePickerID]">
  <signals-time-selector (onTimeChanged)="startTimeChanged($event)" [timepickerID]="timePickerID"></signals-time-selector>
  <span class="seperator">-</span>
  <signals-time-selector
    [selectedTime]="endTime"
    (onTimeChanged)="endTimeChanged($event)"
    [timepickerID]="timePickerID"
  ></signals-time-selector>
</div>
